import {
	Box,
	Divider,
	FormControlLabel,
	FormHelperText,
	Grid,
	Radio,
	RadioGroup,
	Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
	DefaultValues,
	FormProvider,
	SubmitHandler,
	useController,
	useForm,
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FormType } from '@/api/enum/formType.enum';
import {
	Dispatch,
	forwardRef,
	SetStateAction,
	useEffect,
	useImperativeHandle,
	useState,
} from 'react';
import dayjs from 'dayjs';
import AppDatePicker from '@/common/components/form-inputs/AppDatePicker';
import {
	API_DATE_FORMAT,
	DISPLAY_DATE_FORMAT,
	notFutureDate,
} from '@/utils/dateHelper';
import AppTextField from '@/common/components/form-inputs/AppTextField';
import AppFieldView from '@/common/components/form-view/AppFieldView';
import { formatAge } from '@/utils/ageHelper';
import LocalDataGrid from '@/common/components/dataGrid/LocalDataGrid';
import { GridColDef } from '@mui/x-data-grid';

interface Props {
	type: FormType;
	details?: any;
	allEnumList?: any;
	setType: Dispatch<SetStateAction<FormType>>;
}

const EditDsm5AdultForm = forwardRef(
	({ type, setType, details, allEnumList }: Props, ref) => {
		const { t } = useTranslation();

		const [answerList, setAnswerList] = useState([
			{
				id: 1,
				group: 'I',
				title: t(`preAdmission.troubledProblemsTitle1`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 2,
				group: 'I',
				title: t(`preAdmission.troubledProblemsTitle2`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 3,
				group: 'II',
				title: t(`preAdmission.troubledProblemsTitle3`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 4,
				group: 'III',
				title: t(`preAdmission.troubledProblemsTitle4`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 5,
				group: 'III',
				title: t(`preAdmission.troubledProblemsTitle5`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 6,
				group: 'IV',
				title: t(`preAdmission.troubledProblemsTitle6`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 7,
				group: 'IV',
				title: t(`preAdmission.troubledProblemsTitle7`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 8,
				group: 'IV',
				title: t(`preAdmission.troubledProblemsTitle8`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 9,
				group: 'V',
				title: t(`preAdmission.troubledProblemsTitle9`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 10,
				group: 'V',
				title: t(`preAdmission.troubledProblemsTitle10`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 11,
				group: 'VI',
				title: t(`preAdmission.troubledProblemsTitle11`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 12,
				group: 'VII',
				title: t(`preAdmission.troubledProblemsTitle12`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 13,
				group: 'VII',
				title: t(`preAdmission.troubledProblemsTitle13`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 14,
				group: 'VIII',
				title: t(`preAdmission.troubledProblemsTitle14`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 15,
				group: 'IX',
				title: t(`preAdmission.troubledProblemsTitle15`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 16,
				group: 'X',
				title: t(`preAdmission.troubledProblemsTitle16`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 17,
				group: 'X',
				title: t(`preAdmission.troubledProblemsTitle17`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 18,
				group: 'XI',
				title: t(`preAdmission.troubledProblemsTitle18`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 19,
				group: 'XII',
				title: t(`preAdmission.troubledProblemsTitle19`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 20,
				group: 'XII',
				title: t(`preAdmission.troubledProblemsTitle20`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 21,
				group: 'XIII',
				title: t(`preAdmission.troubledProblemsTitle21`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 22,
				group: 'XIII',
				title: t(`preAdmission.troubledProblemsTitle22`) + '*',
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
				answer5: false,
			},
			{
				id: 23,
				group: 'XIII',
				title: t(`preAdmission.troubledProblemsTitle23`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
		]);

		const defaultValues: DefaultValues<any> = {};

		useEffect(() => {
			if (details) {
				methods.reset(details);
				if (details.answerList) {
					const restoredList = answerList?.map((item: any, index: number) => {
						const row: any = {
							...item,
							answer0: false,
							answer1: false,
							answer2: false,
							answer3: false,
							answer4: false,
						};

						row[`answer${details.answerList[index]}`] = true;
						return row;
					});
					setAnswerList(restoredList);
					methods.setValue('answerList', restoredList);
					console.log(restoredList);
				}
			}
		}, [details]);

		const formSchema = Yup.object().shape({
			fillingDate: Yup.string()
				.required(t('errorMessage.pleaseSelect'))
				.test(notFutureDate(t('errorMessage.dateCannotBeFuture'))),
			answerList: Yup.array()
				.of(
					Yup.object().test(
						'at-least-one-answer',
						t('errorMessage.pleaseSelect'), // 错误提示
						(row) => {
							if (!row) return false;
							const { answer0, answer1, answer2, answer3, answer4 } =
								row as any;
							return [answer0, answer1, answer2, answer3, answer4].some(
								(val) => val === true
							);
						}
					)
				)
				.required(t('errorMessage.pleaseSelect')),
		});
		const methods = useForm<any>({
			defaultValues,
			resolver: yupResolver(formSchema),
			mode: 'onChange',
			shouldFocusError: true,
		});

		const answerListField = useController({
			name: 'answerList',
			control: methods.control,
		});

		useImperativeHandle(ref, () => ({
			getFormData: () => methods.getValues(),
			validateForm: () => {
				methods.setValue('answerList', answerList);
				console.log(JSON.stringify(methods.getValues('answerList')));
				methods.trigger();
				methods.formState.isValid;
				return methods.trigger().then(() => methods.formState.isValid);
			},
		}));
		const radioRenderCell = (params: any, score: number) => {
			const { id, row, api } = params;

			const isChecked = row[`answer${score}`] === true;

			const handleChange = () => {
				const updates: Record<string, boolean> = {
					answer0: false,
					answer1: false,
					answer2: false,
					answer3: false,
					answer4: false,
				};
				updates[`answer${score}`] = true;

				api.updateRows([{ id, ...updates }]);
				const list = api.getAllRowIds().map((id: any) => api.getRow(id));
				setAnswerList(list);

				methods.setValue('answerList', list);
				methods.trigger();
			};
			return (
				<Radio checked={isChecked} value={score} onChange={handleChange} />
			);
		};
		const columns: GridColDef[] = [
			{
				field: 'group',
				headerName: '',
				flex: 1,
			},
			{
				field: 'title',
				headerName: t('preAdmission.troubledProblemsTitle'),
				flex: 30,
			},
			{
				field: 'answer0',
				headerName: t('preAdmission.scoreOther1'),
				align: 'center',
				headerAlign: 'center',
				renderHeader: () => (
					<Box>
						<Typography
							variant='body2'
							sx={{ fontWeight: 'bold', textAlign: 'center' }}
						>
							{t('preAdmission.scoreOther1')}
						</Typography>
						<Typography variant='body2' sx={{ textAlign: 'center' }}>
							{t('preAdmission.none')}
						</Typography>
					</Box>
				),
				minWidth: 150,
				renderCell: (params: any) => radioRenderCell(params, 0),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
			{
				field: 'answer1',
				headerName: t('preAdmission.scoreOther2'),
				align: 'center',
				headerAlign: 'center',
				renderHeader: () => (
					<Box>
						<Typography
							variant='body2'
							sx={{ fontWeight: 'bold', textAlign: 'center' }}
						>
							{t('preAdmission.scoreOther2')}
						</Typography>
						<Typography variant='body2' sx={{ textAlign: 'center' }}>
							{t('preAdmission.little')}
						</Typography>
					</Box>
				),
				minWidth: 150,
				renderCell: (params: any) => radioRenderCell(params, 1),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
			{
				field: 'answer2',
				headerName: t('preAdmission.scoreOther3'),
				align: 'center',
				headerAlign: 'center',
				renderHeader: () => (
					<Box>
						<Typography
							variant='body2'
							sx={{ fontWeight: 'bold', textAlign: 'center' }}
						>
							{t('preAdmission.scoreOther3')}
						</Typography>
						<Typography variant='body2' sx={{ textAlign: 'center' }}>
							{t('preAdmission.severalDays')}
						</Typography>
					</Box>
				),

				minWidth: 150,
				renderCell: (params: any) => radioRenderCell(params, 2),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
			{
				field: 'answer3',
				headerName: t('preAdmission.scoreOther4'),
				align: 'center',
				headerAlign: 'center',
				renderHeader: () => (
					<Box>
						<Typography
							variant='body2'
							sx={{ fontWeight: 'bold', textAlign: 'center' }}
						>
							{t('preAdmission.scoreOther4')}
						</Typography>
						<Typography variant='body2' sx={{ textAlign: 'center' }}>
							{t('preAdmission.halfDays')}
						</Typography>
					</Box>
				),
				minWidth: 150,
				renderCell: (params: any) => radioRenderCell(params, 3),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
			{
				field: 'answer4',
				headerName: t('preAdmission.scoreOther5'),
				align: 'center',
				headerAlign: 'center',
				renderHeader: () => (
					<Box>
						<Typography
							variant='body2'
							sx={{ fontWeight: 'bold', textAlign: 'center' }}
						>
							{t('preAdmission.scoreOther5')}
						</Typography>
						<Typography variant='body2' sx={{ textAlign: 'center' }}>
							{t('preAdmission.everyday')}
						</Typography>
					</Box>
				),
				minWidth: 150,
				renderCell: (params: any) => radioRenderCell(params, 4),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
		];
		return (
			<>
				<FormProvider {...methods}>
					<form onSubmit={methods.handleSubmit((e: any) => e.preventDefault())}>
						<Grid container spacing={3} marginTop={0} marginBottom={3}>
							<Grid size={6}>
								<AppFieldView
									label={t('preAdmission.en_name_en')}
									value={details?.nameEn}
								/>
							</Grid>
							<Grid size={6}>
								<AppFieldView
									label={t('preAdmission.zh_name_en')}
									value={details?.nameZh}
								/>
							</Grid>
							<Grid size={6}>
								<AppFieldView
									label={t('preAdmission.zh_age')}
									value={formatAge(
										details?.currentAge,
										details?.currentAgeEstimated,
										'zh'
									)}
								/>
							</Grid>
							<Grid size={6}>
								<AppFieldView
									label={t('preAdmission.zh_sex')}
									value={details?.sexDesc}
								/>
							</Grid>

							<Grid size={6}>
								<AppDatePicker
									control={methods.control}
									name='fillingDate'
									label={t('preAdmission.signatureDate') + '*'}
									maximumDate={dayjs().startOf('day').format(API_DATE_FORMAT)}
								/>
							</Grid>
							<Grid size={6}>
								<AppTextField
									control={methods.control}
									name='relationship'
									label={t('preAdmission.zh_relationship')}
								/>
							</Grid>
							<Grid size={6}>
								<AppTextField
									control={methods.control}
									name='spentTime'
									label={t('preAdmission.spentTime')}
								/>
							</Grid>
						</Grid>

						<Divider sx={{ margin: '24px 0' }} />

						<Typography
							variant='h6'
							sx={{ fontWeight: 'bold' }}
							marginBottom={2}
						>
							{t('preAdmission.questionnaireTitle')}
						</Typography>
						<Typography
							variant='body2'
							sx={{ fontWeight: 'bold' }}
							marginBottom={2}
						>
							{t('preAdmission.Dsm5AdultTips')}
						</Typography>
						<Grid container spacing={3} marginTop={0} marginBottom={3}>
							<Grid size={12} display='flex'>
								<LocalDataGrid
									rows={answerList}
									columns={columns}
									getRowId={(row) => row.id}
									pagination={false}
									rowSpanning={true}
								/>
							</Grid>
						</Grid>
					</form>
					<FormHelperText color='error' style={{ color: '#d32f2f' }}>
						{answerListField.fieldState.error
							? t('errorMessage.pleaseSelect')
							: ''}
					</FormHelperText>
				</FormProvider>
			</>
		);
	}
);

EditDsm5AdultForm.displayName = 'EditDsm5AdultForm';

export default EditDsm5AdultForm;
